import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, TableBody, TableCell, TableHead, TableRow, Box, useMediaQuery, useTheme } from '@mui/material';
import { getSlotItemsForHour, HOURS } from './cUtils';
import { CalendarItemChip } from './components/CalendarItemChip';
import { useTranslation } from 'react-i18next';
export const DayView = ({ date, items, handleOpenModal, isSponsorshipDetailsCalendarTab = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const { t } = useTranslation();
    return (_jsx(Box, { sx: {
            maxHeight: isMobile && isSponsorshipDetailsCalendarTab
                ? 'calc(100vh - 360px)'
                : isSponsorshipDetailsCalendarTab
                    ? 'calc(100vh - 350px)'
                    : 'calc(100vh - 370px)',
            overflowY: 'auto',
            bgcolor: '#fff',
            borderRadius: 3
        }, children: _jsxs(Table, { sx: { minWidth: { xs: '100%', sm: 400 }, bgcolor: '#fff' }, children: [_jsx(TableHead, { children: _jsxs(TableRow, { style: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            background: '#fafbfc'
                        }, children: [_jsx(TableCell, { sx: {
                                    width: 80,
                                    bgcolor: '#fafbfc',
                                    borderBottom: '1px solid #eee',
                                    fontWeight: 500,
                                    color: '#8a8a8a',
                                    textAlign: 'center',
                                    // position: "sticky",
                                    // top: 0,
                                    zIndex: 11,
                                    background: '#fafbfc'
                                }, children: t('fields.time') }), _jsx(TableCell, { sx: {
                                    py: 1.5,
                                    color: '#8a8a8a',
                                    fontWeight: 500,
                                    bgcolor: '#fafbfc',
                                    borderBottom: '1px solid #eee',
                                    textAlign: 'center',
                                    // position: "sticky",
                                    // top: 0,
                                    // zIndex: 11,
                                    background: '#fafbfc'
                                }, children: date.toLocaleDateString(undefined, {
                                    weekday: 'long',
                                    month: 'long',
                                    day: 'numeric',
                                    year: 'numeric'
                                }) })] }) }), _jsx(TableBody, { children: HOURS.map((hour) => {
                        const cellItems = getSlotItemsForHour(items, date, hour);
                        return (_jsxs(TableRow, { children: [_jsx(TableCell, { sx: {
                                        width: 80,
                                        bgcolor: '#fafbfc',
                                        color: '#8a8a8a',
                                        border: '1px solid #f0f0f0',
                                        textAlign: 'center',
                                        fontSize: 14,
                                        fontWeight: 500
                                    }, children: `${hour}:00` }), _jsx(TableCell, { sx: {
                                        height: 48,
                                        verticalAlign: 'top',
                                        border: '1px solid #f0f0f0',
                                        textAlign: 'center',
                                        px: 1,
                                        py: 0.5,
                                        position: 'relative'
                                    }, children: cellItems.map((item) => {
                                        return (_jsx(CalendarItemChip, { item: item, isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab, onClick: () => handleOpenModal?.(item) }, item.id));
                                    }) })] }, hour));
                    }) })] }) }));
};
